module.exports = __webpack_public_path__ + "static/media/LEYLA MUKAYED.119a583e.png";